import MyGoogleMap from 'javascripts/modules/google-map';
import places from 'places.js';

class SearchMap {

	constructor(){
		this._init();
	}

	_init(){
		const args = {
			// streetViewControl: false,
			// panControl:        false,
			// scrollwheel:       false,
			// cluster:           false
		};
	  const map = new MyGoogleMap('search-map', args);

		const searchField = document.querySelector('[data-input="search-map"]');

		if(searchField){

			const placesAutocomplete = places({
				container: searchField
			});

			placesAutocomplete.on('change', function(e) {
				const latlng = e.suggestion.latlng;
				map._moveMarker(latlng);
			});
		}


		
	}

}

export const searchMap = new SearchMap();